/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import useState from "react-usestateref";
import axios from "axios";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
} from "@themesberg/react-bootstrap";
import { ContentTable } from "../../components/Tables";
import { toast } from "react-toastify";

const CATEGORY_LEVEL_OPTIONS = [
  { value: "ordinary", label: "Ordinary" },
  { value: "vip", label: "VIP" },
  { value: "vvip", label: "VVIP" },
  { value: "kibimba", label: "Kibimba" },
  { value: "akatambula", label: "Akatambula" },
  { value: "family", label: "Family" },
  { value: "earlykickoff", label: "Early kickoff" },
  { value: "overs", label: "Overs" },
  { value: "singleandcorporate", label: "Single and Corporate" },
  { value: "doubles", label: "Doubles" },
  { value: "latekickoff", label: "Late kickoff" },
  { value: "normal", label: "Normal" },
  { value: "single", label: "Single" },
  { value: "odd2", label: "Odd 2" },
  { value: "odd3", label: "Odd 3" },
  { value: "supper", label: "Super" },
  { value: "corporate", label: "Corporate" },
  { value: "BigSingle", label: "Big Single" },
  { value: "olukalala", label: "Olukalala" },
];

export default ({ load, handleEditData }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [categories, setCategories] = useState({ docs: [] });
  const [filters, setFilters] = useState({
    category: "",
    active: "",
    categoryLevel: "",
  });

  React.useEffect(() => {
    getCategories();
  }, []);

  React.useEffect(() => {
    getData();
  }, [load, page, filters]);

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.accessToken}`,
    },
  };

  const getCategories = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_API}/v1/category?page=1&limit=100`,
        config
      )
      .then((res) => {
        setCategories(res.data.results || { docs: [] });
      })
      .catch(() => {
        setCategories({ docs: [] });
      });
  };

  const getData = () => {
    setLoading(true);
    const params = new URLSearchParams({ page });
    if (filters.category) params.append("category", filters.category);
    if (filters.active !== "")
      params.append("active", filters.active);
    if (filters.categoryLevel)
      params.append("categoryLevel", filters.categoryLevel);

    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/v1/ticket?${params}`, config)
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
        toast.success("Tickets");
      })
      .catch((err) => {
        setData([]);
        setLoading(false);
        toast.error("Unexpected error");
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const clearFilters = () => {
    setFilters({ category: "", active: "", categoryLevel: "" });
    setPage(1);
  };

  const categoryList = categories.docs ? categories.docs : [];

  return (
    <>
      <Card border="light" className="mb-4 shadow-sm">
        <Card.Body>
          <h5 className="mb-3">Filters</h5>
          <Row>
            <Col xs={12} md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  <option value="">All categories</option>
                  {categoryList.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Category level</Form.Label>
                <Form.Select
                  name="categoryLevel"
                  value={filters.categoryLevel}
                  onChange={handleFilterChange}
                >
                  <option value="">All levels</option>
                  {CATEGORY_LEVEL_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="active"
                  value={filters.active}
                  onChange={handleFilterChange}
                >
                  <option value="">All</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} className="mb-0">
              <Button variant="outline-secondary" onClick={clearFilters}>
                Clear filters
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <ContentTable
        data={data}
        loading={loading}
        setPage={setPage}
        handleEditData={handleEditData}
      />
    </>
  );
};
